import { render, staticRenderFns } from "./DialogStrumentiDiagnostica.vue?vue&type=template&id=4ab1f87c&scoped=true&"
import script from "./DialogStrumentiDiagnostica.vue?vue&type=script&lang=js&"
export * from "./DialogStrumentiDiagnostica.vue?vue&type=script&lang=js&"
import style0 from "./DialogStrumentiDiagnostica.vue?vue&type=style&index=0&id=4ab1f87c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab1f87c",
  null
  
)

export default component.exports